import { render, staticRenderFns } from "./standard_details.vue?vue&type=template&id=56e74145&scoped=true&"
import script from "./standard_details.vue?vue&type=script&lang=js&"
export * from "./standard_details.vue?vue&type=script&lang=js&"
import style0 from "./standard_details.vue?vue&type=style&index=0&id=56e74145&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e74145",
  null
  
)

export default component.exports